import { Component, type ErrorInfo, type ReactNode } from "react";

interface State {
  error?: Error;
}

interface Props {
  children: ReactNode;
  fallback?: (error: Error, reset: () => void) => ReactNode;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = {};

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[ErrorBoundary]", error, info);
  }

  reset = () => this.setState({ error: undefined });

  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback(this.state.error, this.reset);
      return (
        <div className="min-h-[40vh] flex items-center justify-center p-8">
          <div className="glass-strong rounded-card p-6 max-w-md text-center">
            <h2 className="text-xl font-heading mb-2">Errore inatteso</h2>
            <p className="text-sm text-muted mb-4">{this.state.error.message}</p>
            <button
              type="button"
              onClick={this.reset}
              className="rounded-full bg-accent text-white px-5 py-2 text-sm font-heading"
            >
              Riprova
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
